// src/components/dashboard/DashboardApp.js
import React, { useState } from "react";
import DashboardSidebar from "../components/postanalysis components/ui/DashboardSidebar";
import DashboardSummary from "@/components/postanalysis components/tabs/PA_Summary";
import DashboardInsights from "@/components/postanalysis components/tabs/PA_DetailedInsights";
import DashboardBenchmarks from "@/components/postanalysis components/tabs/PA_Benchmarks";
import DashboardROI from "@/components/postanalysis components/tabs/PA_ROI";
import POCLevelAnalysis from "@/components/postanalysis components/tabs/PA_POCLevelAnalysis";
import Glossary from "@/components/postanalysis components/tabs/PA_Glossary";
import { useTheme } from "next-themes";
import { useNavbarVisibility } from '@/context/NavbarVisibilityContext';

export default function PostAnalysis() {
  const [activeTab, setActiveTab] = useState("summary");
  const { theme, setTheme } = useTheme();
  const [filters, setFilters] = useState({
    brand: "",
    region: "",
    campaign: "",
    poc_id: [],
    key_account: "",
    start_date: "",
    end_date: ""
  });
  const { navbarVisible } = useNavbarVisibility();

  const renderTabContent = () => {
    switch (activeTab) {
      case "summary":
        return <DashboardSummary filters={filters} setFilters={setFilters} />;
      case "insights":
        return <DashboardInsights filters={filters} setFilters={setFilters} />;
      case "benchmarks":
        return <DashboardBenchmarks filters={filters} setFilters={setFilters} />;
      case "roi":
        return <DashboardROI filters={filters} setFilters={setFilters} />;
      case "poc-level-analysis":
        return <POCLevelAnalysis filters={filters} setFilters={setFilters} />;
      case "glossary":
        return <Glossary filters={filters} setFilters={setFilters} />;
      default:
        return null;
    }
  };

  return (
      // <div className="min-h-screen flex" style={{backgroundImage:`url(${BackgroundImage})`,backgroundSize:"cover"}}>
      <div className="min-h-screen flex">
        <div className="fixed left-0 w-52 h-full flex-shrink-0 transition-all duration-300 top-0">
          <DashboardSidebar
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            darkMode={theme === 'dark'}
            setDarkMode={(isDark) => setTheme(isDark ? 'dark' : 'light')}
          />
        </div>
        <div className="flex-1 ml-52 overflow-x-auto pt-24">
          <div className="py-2 pr-2 pl-0 max-w-full">
            {renderTabContent()}
          </div>
        </div>
      </div>
  );
}
